export const ISSUE_PRIORITY = {
  LOW: { displayName: "Low", value: 1, name: "LOW" },
  MEDIUM: { displayName: "Medium", value: 2, name: "MEDIUM" },
  HIGH: { displayName: "High", value: 3, name: "HIGH" },
};
